import { useOutletContext } from "react-router-dom";
import TemplatesPage from "@/pages/app/TemplatesPage";
import ChatPage from "@/pages/app/ChatPage";

export function TemplatesRoute() {
  return <TemplatesPage />;
}

export function ChatRoute() {
  const { me } = useOutletContext();
  return <ChatPage role={me?.user?.role} />;
}
